module.exports = __webpack_public_path__ + "static/media/IMG_1715.4e7fc3cc.jpg";